export const custom_model_Data = [
    {
        designId: "079b275f-e58b-441b-b324-2884579a63dc",
        meshes: [
            { mesh_name: "BASE_1", canChange: false },
            { mesh_name: "INSIDE_1", canChange: true },
            { mesh_name: "TOP_1", canChange: true },
        ],
        materialSelection: false,
        targetMesh: "TAPE_1",
        materials: []
    },
    {
        designId: "6bb92dd2-aa14-407d-ad36-11ef835fd09d",
        meshes: [
            { mesh_name: "BASE_1", canChange: true },
            { mesh_name: "Gold_1", canChange: false },
            { mesh_name: "TAPE_1", canChange: true },
            { mesh_name: "TOP_1", canChange: true },
        ],
        materialSelection: true,
        targetMesh: "TAPE_1",
        materials: [{ name: "GoldTapeMtl", imageLink: "/buttonImages/gold.png" }, { name: "TapeMtl", imageLink: "/buttonImages/silver.png" }]
    },
    {
        designId: "85c9cbc1-d0b7-4a60-9cd3-7885b3cd7b7c",
        meshes: [
            { mesh_name: "BASE_1", canChange: false },
            { mesh_name: "INSIDE_1", canChange: true },
            { mesh_name: "TOP_1", canChange: true },
        ],
        materialSelection: false,
        targetMesh: "TAPE_1",
        materials: []
    }
]